export function hexaToRgba(hexa) {
  if (hexa === null) return null
  let r = parseInt("0x" + hexa.color.substring(0, 2))
  let g = parseInt("0x" + hexa.color.substring(2, 4))
  let b = parseInt("0x" + hexa.color.substring(4, 6))
  let a = hexa.opacity
  return "rgba(" + r + "," + g + "," + b + "," + a + ")"
}

export function hexaToDark(hexa) {
  if (hexa === null) return false
  let r = parseInt("0x" + hexa.color.substring(0, 2))
  let g = parseInt("0x" + hexa.color.substring(2, 4))
  let b = parseInt("0x" + hexa.color.substring(4, 6))
  return r + g + b < 550 ? true : false
}

export function formatTime(time) {
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ]
  const split = time.split("-")
  const year = split[0]
  const month = months[parseInt(split[1]) - 1]
  const day = split[2].split("T")[0]
  return day + " " + month + " " + year
}
